import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Tree.css";

function Tree() {
  
  const [ornaments, setOrnaments] = useState([]); // State to hold ornaments
  const [nextPage, setNextPage] = useState(null);
  const [prevPage, setPrevPage] = useState(null);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const [clickedOrnament, setClickedOrnament] = useState(null); // Track clicked ornament
  const [showAnimation, setShowAnimation] = useState(false); // State to track animation visibility
  const [showImage, setShowImage] = useState(false);

  // Define two sets of positions
  const oddPagePositions = [
    { top: "10vh", left: "23vw" },  // Row 1 - 
    { top: "15vh", left: "20vw" },  // Row 2 - Center
    { top: "15vh", left: "28vw" },  // Row 2 - Right
    { top: "24vh", left: "16vw" },  // Row 3 - Far left
    { top: "25vh", left: "21vw" },  // Row 3 - Left
    { top: "24vh", left: "26vw" },  // Row 3 - Right
    { top: "22vh", left: "30vw" },  // Row 3 - Far right
    { top: "37vh", left: "20vw" },  // Row 4 - Far left
    { top: "46vh", left: "19vw" },  // Row 4 - Left
    { top: "38vh", left: "32vw" },  // Row 4 - Center
    { top: "34vh", left: "14vw" },  // Row 4 - Far far left
    { top: "46vh", left: "13vw" },  // Bottom - Right
    { top: "48vh", left: "23vw" },  // Botoom - Far right
    { top: "46vh", left: "29vw" },  // Bottom-center of the pyramid
  ];
  const evenPagePositions = [
    { top: "10.1vh", left: "23.1vw" },  // Row 1 - 
    { top: "15.1vh", left: "19.9vw" },  // Row 2 - Center
    { top: "15.1vh", left: "27.9vw" },  // Row 2 - Right
    { top: "24.1vh", left: "16.1vw" },  // Row 3 - Far left
    { top: "24.9vh", left: "21.1vw" },  // Row 3 - Left
    { top: "23.9vh", left: "25.9vw" },  // Row 3 - Right
    { top: "22.05vh", left: "29.9vw" },  // Row 3 - Far right
    { top: "37.1vh", left: "20.9vw" },  // Row 4 - Far left
    { top: "46.1vh", left: "18vw" },  // Row 4 - Left
    { top: "37.9vh", left: "32.1vw" },  // Row 4 - Center
    { top: "33.9vh", left: "14.1vw" },  // Row 4 - Far far left
    { top: "46vh", left: "13.1vw" },  // Bottom - Right
    { top: "48.1vh", left: "22.9vw" },  // Botoom - Far right
    { top: "45.9vh", left: "28.9vw" },  // Bottom-center of the pyramid
  ];
  // Fetch ornaments on component mount or when the page changes
  const fetchOrnaments = async (page = 1) => {
    try {
      //dev
      //const response = await axios.get(`/api/ornaments-subset/?page=${page}`);
      //production
      const API_URL = process.env.REACT_APP_API_URL;
      const response = await axios.get(`${API_URL}/api/ornaments-subset/?page=${page}`);

      setOrnaments(response.data.results); // Store ornaments
      setNextPage(response.data.next); // Store next page URL
      setPrevPage(response.data.previous); // Store next page URL
    } catch (error) {
      console.error("Error fetching ornaments:", error);
    }
  };
  // Handle ornament click
  const handleOrnamentClick = (id) => {
    setClickedOrnament(id); // Set clicked ornament ID
  };
  const movingImages = [
    { id: 1, url: `${process.env.REACT_APP_API_URL}/static/images/teri_1.png` },
    { id: 2, url: `${process.env.REACT_APP_API_URL}/static/images/teri_2.png`  },
    { id: 3, url: `${process.env.REACT_APP_API_URL}/static/images/teri_3.png`  },
    { id: 4, url: `${process.env.REACT_APP_API_URL}/static/images/teri_1.png`  },
    { id: 5, url: `${process.env.REACT_APP_API_URL}/static/images/teri_2.png`  },
    { id: 6, url: `${process.env.REACT_APP_API_URL}/static/images/teri_3.png`  },
    { id: 7, url: `${process.env.REACT_APP_API_URL}/static/images/teri_1.png` },
    { id: 8, url: `${process.env.REACT_APP_API_URL}/static/images/teri_2.png`  },
    { id: 9, url: `${process.env.REACT_APP_API_URL}/static/images/teri_3.png`  },
    { id: 10, url: `${process.env.REACT_APP_API_URL}/static/images/teri_1.png`  },
    { id: 11, url: `${process.env.REACT_APP_API_URL}/static/images/teri_2.png`  },
    { id: 12, url: `${process.env.REACT_APP_API_URL}/static/images/teri_3.png`  },
    { id: 13, url: `${process.env.REACT_APP_API_URL}/static/images/teri_1.png`  },
    { id: 14, url: `${process.env.REACT_APP_API_URL}/static/images/teri_2.png`  },
    { id: 15, url: `${process.env.REACT_APP_API_URL}/static/images/teri_3.png`  },
    { id: 16, url: `${process.env.REACT_APP_API_URL}/static/images/teri_1.png`  },
    { id: 17, url: `${process.env.REACT_APP_API_URL}/static/images/teri_2.png`  },
    { id: 18, url: `${process.env.REACT_APP_API_URL}/static/images/teri_3.png`  },
    { id: 19, url: `${process.env.REACT_APP_API_URL}/static/images/teri_1.png`  },
  ]; // Add your image URLs here
  

  // Load the first set of ornaments when the component mounts
  useEffect(() => {
    fetchOrnaments(currentPage);
  }, [currentPage]);
  const handleNextPage = () => {
    if (nextPage) {
      setCurrentPage(currentPage + 1); // Increment page number
    }
  };
  const handlePrevPage = () => {
    if (prevPage) {
      setCurrentPage(currentPage - 1); // Increment page number
    }
  };

  return (
    <div className="tree-container">
      <div className="tree">
        {/* Display ornaments at fixed positions */}
        {ornaments.map((ornament, index) => {
          const position = currentPage % 2 === 0 ? evenPagePositions[index % evenPagePositions.length] : oddPagePositions[index % oddPagePositions.length];
          const isClicked = clickedOrnament === ornament.id; // Check if ornament is clicked
          return (
            <div
              key={ornament.id}
              className={`ornament ${isClicked ? 'glow' : ''}`} // Apply glow class if clicked
              style={{
                position: "absolute",
                top: position.top,
                left: position.left,
              }}
              onClick={() => handleOrnamentClick(ornament.id)} // Handle click
            >
              <img
                //src={ornament.image_url}
                src = { `${process.env.REACT_APP_API_URL}${ornament.image_url}`}
                alt="Ornament"
                onClick={() => alert(ornament.message)}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          );
        })}
      </div>

      {/* Cat Images */}
      {/*Cat 1 (Left) */}
      <div class="cat left"
        onClick={() => setShowAnimation(true)}>
      </div>
      {/* Cat 2 (Right) */}
      <div class="cat right"
        onClick={() => setShowImage(!showImage)} >
      </div>
      
      <div className="page_scroll_div">
        {/* Prev Page Button */}
        {prevPage && (
          <button
            className="page_buttons prev-button"
            onClick={handlePrevPage}
          >
            &lt; 
          </button>
        )}

        {/* Next Page Button */}
        {nextPage && (
          <button
            className="page_buttons next-button"
            onClick={handleNextPage}
          >
            &gt; 
          </button>
        )}
      </div>
      {/* Moving Images at the Bottom */}
      {showAnimation && (
        <div className="moving-images-container">
          {movingImages.map((image, index) => (
            <img
              key={image.id}
              src={image.url}
              alt={`anchovy ${index + 1}`}
              style={{
                animationDelay: `${index * 1}s`, // Stagger animation start
              }}
            />
          ))}
        </div>)
      }
      {/* Conditional Image */}
      {showImage && (
        <div className="centered-image">
          {/*<img src="/static/images/jae.png" alt="Popup" />*/}
          <img 
            src={`${process.env.REACT_APP_API_URL}/static/images/jae.png`} 
            alt="Popup" 
          />
        </div>
      )}
    </div>
  );
}

export default Tree;
